interface NavigationHistoryEntry {
  id: string;
  key: string;
  index: number;
  url: string;
  sameDocument: boolean;
}

interface Navigation {
  canGoBack: boolean;
  canGoForward: boolean;
  currentEntry: NavigationHistoryEntry;
  entries: () => NavigationHistoryEntry[];
}

/**
 * @description the current route can be returned
 * @author liuchuan
 */
export const canGoBack = (): boolean => {
  if ('navigation' in window) {
    const { canGoBack, currentEntry, entries } =
      window.navigation as Navigation;
    const { index } = currentEntry;

    return canGoBack || (index > 0 && entries()[index - 1].sameDocument);
  }
  return history.state && history.state.idx > 0;
};
